import cn from 'classnames';
import React from 'react';
import { useAppContext } from 'src/context/store/app-provider';

import styles from './styles.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  mobileResize?: number;
}

export function LearnMoreContainer({ children, className, ...props }: Props) {
  const { isRtl } = useAppContext();

  return (
    <div
      id="TabbyDialogContainer"
      className={cn(styles.body, className, {
        [styles.bodyRtl]: isRtl,
      })}
      data-test="widget-container"
      {...props}
    >
      {children}
    </div>
  );
}
